import React, {useState, useEffect, useRef} from 'react';
import UploadStep from '../components/UploadStep';
import SummaryDetails from '../components/SummaryDetails';
import ClassRecommendations from '../../shared/components/UIElements/ClassRecommendations';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import ProgressBar from 'react-bootstrap/ProgressBar'
import CustomProgressBar from  '../../shared/components/UIElements/CustomProgressBar';

import './Recommender.css';

const Recommender = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isMatching, setIsMatching] = useState(false);
  const [current, setCurrent] = useState(2);
  const [recMessage, setRecMessage] = useState('Summarizing...');
   const [file, setFile] = useState();
   const [endpoint, setEndpoint] = useState('');
   const [spatialClasses, setSpatialClasses] = useState();
   const [spatialClass, setSpatialClass] = useState();
   const [parsedDataset, setParsedDataset] = useState();
   const [getSpClassesButtonValid, setGetSpClassesButtonValid] = useState(false);
   const [isValid, setIsValid] = useState(false);
   const [recommendations, setRecommendations] = useState();
   const [datasetFormat, setDatasetFormat]= useState("endpoint");
   const [error, setError] = useState();
   const [parsedFormat, setParsedFormat] = useState();
   const [parsedURL, setParsedURL] = useState();
   const [parsedURI, setParsedURI] = useState();
  // const datasetFormatRef=useRef(datasetFormat);
  //const proxyurl = "https://cors-anywhere.herokuapp.com/";

  useEffect(()=>{
    window.scrollTo(0, 0);
 },[]);

   const selectFile = event =>{
    let pickedFile;
    if (event.target.files && event.target.files.length === 1) {
      pickedFile = event.target.files[0];
      setFile(pickedFile);
      setIsValid(true);
    } else {
      setIsValid(false);
    }
    }

    const getSpatialClasses = async () =>{
      try{
          setIsLoading(true);
          setSpatialClasses(null);
          setParsedDataset ();
          setRecommendations();

          const response = await fetch(process.env.REACT_APP_BACKEND_API_URL+'/proxy/classes/'+encodeURIComponent(endpoint));      
          if (! await response.ok){
              setError("Could not parse Endpoint. \n"
          +" Please ensure that you provide a valid SPARQL Endpoint URL"
          +" e.g. https://dbpedia.org/sparql. \n Maybe the Endpoint is inactive or does not allow queries ");
              setIsLoading(false);
          }else{
              const results=await response.json();
              const spclasses=results//.results.bindings;
              if (spclasses.length===0) {
                   setError("No spatial classes found for this Endpoint.");
                   setIsValid(false);
              }else{
                  setSpatialClasses(spclasses);
                  selectClassHandler(spclasses[0].t.value)
                  setIsValid(true);
              }
              
          }    
          setIsLoading(false);
      }catch (err) {
          setError(err.message+
          +"\n Please ensure that you provide a valid SPARQL Endpoint URL "
          +" e.g. https://dbpedia.org/sparq. \n Maybe the Endpoint is inactive or does not allow queries ");
          setIsLoading(false);
      }
  }

  const endpointTextChangeHandler = val => {
     val.startsWith('http') ?setGetSpClassesButtonValid(true):setGetSpClassesButtonValid(false);
     setEndpoint(val);  
     };
  

   const parseFile = async event => {
      event.preventDefault();
      
      try {
       setIsLoading(true);
       setParsedDataset ();
       setRecommendations();
     
      if (isValid){
          const formData = new FormData();
          formData.append('file', file);
          formData.append('format', datasetFormat);
          if (datasetFormat==='endpoint'){
            const response = await fetch(process.env.REACT_APP_BACKEND_API_URL+'/proxy/class/'+encodeURIComponent(endpoint)+'/'+encodeURIComponent(spatialClass))
            if (! await response.ok){
              setError("Could not parse selected Class!");
              setIsLoading(false);
              throw "Could not parse selected Class!";
            }else{
              const results=await response.json();
             formData.append('json',await JSON.stringify(results));//.results.bindings));
              //formData.append('json',results.results.bindings);
              formData.append('cs',spatialClass);
            }  
          } 
          const response = await fetch(process.env.REACT_APP_BACKEND_API_URL+'/recommender/upload',{method:'POST', body:formData});
          if ( !response.ok){
            const err=await response.json();
            setError(err.message);
            setIsLoading(false);
          }else{
              setParsedDataset ( await response.json());
              if (datasetFormat==='endpoint'){
                  setParsedFormat('endpoint');
                  setParsedURL(endpoint);
                  setParsedURI(spatialClass);
              }else{
                setParsedFormat(datasetFormat);
                 setParsedURL("0");
                 setParsedURI("0");
              }
              setRecommendations(null);
          }
        }else{
          setError("No dataset provided!");
          setIsLoading(false);
        }
      
        setIsLoading(false);
      } catch (err) {
        setError(err.message +"Could not parse provided dataset!");
        setIsLoading(false);
      }
    };

    const getRecommendations = async event => {
      try {
        setIsMatching(true);
        setRecommendations();
        setRecMessage("Summarizing...");
        let stcur=4;
        setCurrent(stcur); 
        let timer=setInterval(()=>{if (stcur<26){stcur=stcur+2; setCurrent(stcur)}},5000)
        let response =  await fetch(process.env.REACT_APP_BACKEND_API_URL+'/recommender/recommend/summary/'+encodeURIComponent(parsedDataset.id));
        const summary=await response.json();
        clearInterval(timer)
        
        setRecMessage("Filtering...");
        stcur=25;
        setCurrent(stcur);  
        response =  await fetch(process.env.REACT_APP_BACKEND_API_URL+'/recommender/recommend/filter/',{method:'POST',  headers: {'Accept': 'application/json','Content-Type': 'application/json' },body:JSON.stringify({summary:summary})});
        const candidates=await response.json();
        
        setRecMessage(candidates.length +" candidates found. Matching...");
        stcur=30;
        setCurrent(stcur);
        //let estTime=Math.round( parseInt(candidates.length)*0.5 );
        //let factor=Math.round(estTime/5);
        //if (factor===0) factor=1;
        //const step=Math.round(70/factor);

        const area_factor=candidates.area_class/4
        let num_of_recs=candidates.length
        if (num_of_recs===0) num_of_recs=1
        const estTime=num_of_recs*area_factor;
        const step=parseInt((estTime/7)*1000)
       // console.info(area_factor)
       // console.info(estTime)
       // console.info(step)
        timer=setInterval(()=>{if (stcur<100) {stcur=stcur+10; setCurrent(stcur);}}, step);
        response =  await fetch(process.env.REACT_APP_BACKEND_API_URL+'/recommender/recommend/match/',{method:'POST',  headers: {'Accept': 'application/json','Content-Type': 'application/json' },body:JSON.stringify({cells:candidates.cells,candidates:candidates.candidates})});
        const recs=await response.json();
        clearInterval(timer);

        setRecommendations (recs);
        setIsMatching(false);
      } catch (err) {
        console.info(err)
        setIsMatching(false);
      }
    };

   const datasetFormatChangeHandler =(val) =>{
      setDatasetFormat(val);
      setIsValid(false);
      setSpatialClasses(null);
      setFile(null);
   }

   const selectClassHandler = (val)=>{
      setSpatialClass(val);
   }


   const clearError = () => {
    setError(null);
  };
  // {isMatching && <ProgressBar animated now={current} label={`${current}%`}/>}
    return (
      
    <div className="mainRecommenderDiv">
     
    <ErrorModal error={error} onClear={clearError} />
       {isLoading &&(<div className="center"><LoadingSpinner asOverlay/></div>)} 
       {isMatching && <CustomProgressBar message={recMessage}><ProgressBar animated now={current} variant="info" label={`${current}%`} /></CustomProgressBar>}
       <div>
         <UploadStep onUpload={parseFile}
                     onChange={selectFile}
                     onEndpointChange={(e)=>endpointTextChangeHandler(e.target.value)}
                     endpointValue={endpoint}
                     getSpatialClasses={getSpatialClasses}
                     spatialClasses={spatialClasses}
                     spatialClass={spatialClass}
                     spclButtonValid={getSpClassesButtonValid}
                     onSpatialClassChange={(e)=>selectClassHandler(e.target.value)}
                     df={datasetFormat}
                     valid={isValid}
                     onDFChange={(v)=>datasetFormatChangeHandler(v.target.value)}   
                     />
          
         {parsedDataset && <SummaryDetails dataset={parsedDataset} recommendationsHandler={getRecommendations}/>}
         </div>
       
         {recommendations && <ClassRecommendations recs={recommendations} format={parsedFormat} dataset={parsedURL} cs={parsedURI} ontology="W3C Basic Geo"/>}
        </div>
         );
    
  };
  
  export default Recommender;